import React from 'react';
import UnifiedResetSuccess from '@components/UnifiedResetSuccess';
import { getHostname } from '@services/utils';

const ResetSuccess: React.FC = () => {
  const hostname = getHostname();
  const theme = hostname.includes('dxscontrols') ? 'light' : 'dark';
  return <UnifiedResetSuccess theme={theme} />;
};

export default ResetSuccess;